import React from 'react'
import styles from './CategoryTree.module.scss'

function CategoryTree({ title, subTitle }) {
	return (
		<div className={styles.CategoryTree}>
			<h3>{title}</h3>
			<ul className={styles.CategoryTreeItem}>
				{subTitle.map((item, index) => (
					<li key={index}>
						<span>{item}</span>
					</li>
				))}
			</ul>
		</div>
	)
}

export default CategoryTree
